export const GetEshopData = "GetEshopData"
export const IsPreviewEshop = "IsPreviewEshop"
export const IsInquiryModalOpen = "IsInquiryModalOpen"
export const ISStoreDetailModal = "ISStoreDetailModal"
export const NumOfPersons = "NumOfPersons"
export const TwoDates = "TwoDates"
export const PriceCalculation = "PriceCalculation"
export const ISEshopButtonEnabled = "ISEshopButtonEnabled"
